module.exports = __webpack_public_path__ + "static/media/reportBadgeLevel1Locked.2e68b284.png";